// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RigisterFormParent{
    color: #666666;
}
.RigisterFormParent label{
line-height: 1;
font-weight: 400;
text-transform: capitalize;
}

.RigisterFormParent p{
    line-height: 1;
    font-weight: 400;
    text-transform: capitalize;
}


.RigisterFormParent input{
    padding: 1rem;
    border: 1px solid #ced4da;
    background-color: #fff;
    border-radius: 0.25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;

    }

    .RigisterFormParent textarea{
        padding: 1rem;
        border: 1px solid #ced4da;
        background-color: #fff;
        border-radius: 0.25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    
        }
    
.header-register{
    color: var(--t-black);
    display: flex;
    justify-content: center;
    align-items: center;
}

.formParent{
display: flex;
justify-content: center;
width: 100%;
margin:4rem 0rem;


}

.registrationForm{
    width: 75%;
    border: 1px solid #ced4da;

    border-radius: 10px;
    padding: 3rem;
    box-sizing: border-box;
}

.formInputs{
    display: flex;
    flex-wrap: wrap;
    justify-content:space-between;
    
}

.formInputs>div{
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
    width: 48%;
    margin-bottom: 1.5rem;
}

.formInputs>div>input{
   height: 2.5rem;
   width: 100%;
   border-radius: 3px;


}

.formOptions{
    display: flex;
    justify-content: space-between;
}

.radioDiv{
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.radioDiv>div{
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
}

.radioDiv>div>div{
    display: flex;
    gap: 0.8rem;
}

.reason{
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
}
.reason div{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
}
.reason>div>textarea{
    width: 100%;
    resize: none;
}


.imageInput{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
}

.imageInput>div{
    display: flex;
    gap: 1rem;
    align-items: center;
}
.imageInput>div>label>img{
    width: 2.5rem;
   cursor: pointer;
   transition: all 250ms linear;
   
}
.imageInput>div>label>img:hover{
    transform: scale(1.1);
   
}

.socialBox{
    display: flex;
    width: 100%;
    margin-bottom: 1.5rem;
}
.social{
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 25%;
}

.social label{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
}

.submitBtn{
    border: 1px solid var(--t-white);
    line-height: 0rem;
    padding: 1.5rem 2rem;
    color: var(--t-white);
    background-color: var(--t-red);
    font-size: 1rem;
    font-weight:700;
    font-family: 'Archivo', sans-serif;
    text-decoration: none;
    width: 25%;
}

.submitBtn:hover{
    line-height: 0rem;
    padding: 1.5rem 2rem;
    border: 1px solid var(--t-red);
    background-color: var(--t-white);
    color: var(--t-red);
}
/* /////////////for country input/////////// */
.css-b62m3t-container {
    width: 100% !important;
}
.css-13cymwt-control {
    min-height: 2.5rem;
    border-radius: 3px;
}

@media only screen and (max-width: 600px) {
    .registrationForm {
        width: 90%;
        padding: 1rem;
    }
    .formInputs{
        width: 100%;
        flex-direction: column;
    }
    .formInputs>div{
        width: 100%;
    }
    .formOptions{
        flex-direction: column;
    }
    .socialBox{
        display: flex;
        flex-direction: column;
    }
    .radioDiv{
        width: 100%;
    }
    .imageInput{
        align-items: normal;
    }
    .imageInput>div {
        flex-direction: column;
    }
    .social{
        width: 100%;
        margin-bottom: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/FormDelegate/FormDelegate.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;AACA;AACA,cAAc;AACd,gBAAgB;AAChB,0BAA0B;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,0BAA0B;AAC9B;;;AAGA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;IACtB,qEAAqE;;IAErE;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,sBAAsB;QACtB,sBAAsB;QACtB,qEAAqE;;QAErE;;AAER;IACI,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;AACA,aAAa;AACb,uBAAuB;AACvB,WAAW;AACX,gBAAgB;;;AAGhB;;AAEA;IACI,UAAU;IACV,yBAAyB;;IAEzB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;;AAEjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,qBAAqB;AACzB;;AAEA;GACG,cAAc;GACd,WAAW;GACX,kBAAkB;;;AAGrB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,aAAa;GACd,eAAe;GACf,4BAA4B;;AAE/B;AACA;IACI,qBAAqB;;AAEzB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;IACrB,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,kCAAkC;IAClC,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,8BAA8B;IAC9B,gCAAgC;IAChC,mBAAmB;AACvB;AACA,8CAA8C;AAC9C;IACI,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,UAAU;QACV,aAAa;IACjB;IACA;QACI,WAAW;QACX,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;AACJ","sourcesContent":[".RigisterFormParent{\n    color: #666666;\n}\n.RigisterFormParent label{\nline-height: 1;\nfont-weight: 400;\ntext-transform: capitalize;\n}\n\n.RigisterFormParent p{\n    line-height: 1;\n    font-weight: 400;\n    text-transform: capitalize;\n}\n\n\n.RigisterFormParent input{\n    padding: 1rem;\n    border: 1px solid #ced4da;\n    background-color: #fff;\n    border-radius: 0.25rem;\n    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n\n    }\n\n    .RigisterFormParent textarea{\n        padding: 1rem;\n        border: 1px solid #ced4da;\n        background-color: #fff;\n        border-radius: 0.25rem;\n        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    \n        }\n    \n.header-register{\n    color: var(--t-black);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.formParent{\ndisplay: flex;\njustify-content: center;\nwidth: 100%;\nmargin:4rem 0rem;\n\n\n}\n\n.registrationForm{\n    width: 75%;\n    border: 1px solid #ced4da;\n\n    border-radius: 10px;\n    padding: 3rem;\n    box-sizing: border-box;\n}\n\n.formInputs{\n    display: flex;\n    flex-wrap: wrap;\n    justify-content:space-between;\n    \n}\n\n.formInputs>div{\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    justify-content: center;\n    align-items: center;\n    width: 48%;\n    margin-bottom: 1.5rem;\n}\n\n.formInputs>div>input{\n   height: 2.5rem;\n   width: 100%;\n   border-radius: 3px;\n\n\n}\n\n.formOptions{\n    display: flex;\n    justify-content: space-between;\n}\n\n.radioDiv{\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.radioDiv>div{\n    display: flex;\n    flex-direction: column;\n    gap: 0.6rem;\n}\n\n.radioDiv>div>div{\n    display: flex;\n    gap: 0.8rem;\n}\n\n.reason{\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1.5rem;\n    margin-bottom: 1.5rem;\n}\n.reason div{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 1.5rem;\n    width: 100%;\n}\n.reason>div>textarea{\n    width: 100%;\n    resize: none;\n}\n\n\n.imageInput{\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.5rem;\n    margin-bottom: 1.5rem;\n}\n\n.imageInput>div{\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n}\n.imageInput>div>label>img{\n    width: 2.5rem;\n   cursor: pointer;\n   transition: all 250ms linear;\n   \n}\n.imageInput>div>label>img:hover{\n    transform: scale(1.1);\n   \n}\n\n.socialBox{\n    display: flex;\n    width: 100%;\n    margin-bottom: 1.5rem;\n}\n.social{\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 25%;\n}\n\n.social label{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.submitBtn{\n    border: 1px solid var(--t-white);\n    line-height: 0rem;\n    padding: 1.5rem 2rem;\n    color: var(--t-white);\n    background-color: var(--t-red);\n    font-size: 1rem;\n    font-weight:700;\n    font-family: 'Archivo', sans-serif;\n    text-decoration: none;\n    width: 25%;\n}\n\n.submitBtn:hover{\n    line-height: 0rem;\n    padding: 1.5rem 2rem;\n    border: 1px solid var(--t-red);\n    background-color: var(--t-white);\n    color: var(--t-red);\n}\n/* /////////////for country input/////////// */\n.css-b62m3t-container {\n    width: 100% !important;\n}\n.css-13cymwt-control {\n    min-height: 2.5rem;\n    border-radius: 3px;\n}\n\n@media only screen and (max-width: 600px) {\n    .registrationForm {\n        width: 90%;\n        padding: 1rem;\n    }\n    .formInputs{\n        width: 100%;\n        flex-direction: column;\n    }\n    .formInputs>div{\n        width: 100%;\n    }\n    .formOptions{\n        flex-direction: column;\n    }\n    .socialBox{\n        display: flex;\n        flex-direction: column;\n    }\n    .radioDiv{\n        width: 100%;\n    }\n    .imageInput{\n        align-items: normal;\n    }\n    .imageInput>div {\n        flex-direction: column;\n    }\n    .social{\n        width: 100%;\n        margin-bottom: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
